import { render, staticRenderFns } from "./RecordDialog2.vue?vue&type=template&id=c25e3be8&scoped=true&"
import script from "./RecordDialog2.vue?vue&type=script&lang=js&"
export * from "./RecordDialog2.vue?vue&type=script&lang=js&"
import style0 from "./RecordDialog2.vue?vue&type=style&index=0&id=c25e3be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25e3be8",
  null
  
)

export default component.exports